import { createSelector } from '@reduxjs/toolkit';
import isEmpty from 'lodash/isEmpty';

import type { RootState } from '@/store';

import { BookingChannelTypes } from '@/constants/settings';
import { FM_AGENCY_ID_KEY, FM_AGENT_ID_KEY } from '@/ducks/fm/constants';

export const selectAgentData = (state: RootState) => state.agentData;
export const selectIsAgencyDataAvailable = (state: RootState) => !isEmpty(selectAgentData(state));

export const selectAgencyDefaultCurrencyCode = (state: RootState) => selectAgentData(state)?.agencyCurrencyCode;

export const selectAgencyDetails = (state: RootState) => selectAgentData(state)?.agencyDetails;
export const selectAgencyCurrencies = (state: RootState) => selectAgencyDetails(state)?.multiCurrencies;
export const selectAgencyId = (state: RootState) => selectAgencyDetails(state)?.agencyId;

export const selectAgentDetails = (state: RootState) => selectAgentData(state)?.agentDetails;
export const selectAgentDetailsIsValid = (state: RootState) => selectAgentDetails(state)?.isValid;
export const selectAgentId = (state: RootState) => selectAgentDetails(state)?.agentId;

export const selectAgentCurrencyCode = (state: RootState) => selectAgentDetails(state)?.currency;

export const selectAgentBookingChannel = (state: RootState) => selectAgentDetails(state)?.bookingChannel;

export const selectFilterAgencyIsAvailable = (state: RootState) => {
  const agencyId = selectAgencyId(state);
  const agentId = selectAgentId(state);
  const bookingChannel = selectAgentBookingChannel(state);

  return Boolean(agencyId || agentId) && bookingChannel === BookingChannelTypes.fmLink;
};

export const selectFmSearchParams = createSelector(
  selectIsAgencyDataAvailable,
  selectAgentId,
  selectAgencyId,
  (isFm, agentId, agencyId) =>
    isFm
      ? {
          [FM_AGENCY_ID_KEY]: agencyId,
          [FM_AGENT_ID_KEY]: agentId,
        }
      : {},
);
